export const COMPANY = {
  name: "KS RENT SERVICES",
  brand: "KS Rent Services",
  shortBrand: "KS",
  website: "https://www.ksrentservices.com",
  email: "contact@ksrentservices.com",
  phoneDisplay: "06 60 15 98 00",
  phoneIntl: "+33660159800",
  whatsappIntl: "33660159800",
  /**
   * Adresse PUBLIQUE, la même que la fiche Google et les annuaires (consigne de
   * Meymoun, 10/10/2026). L'adresse de `legal` est la DOMICILIATION : elle ne
   * sert qu'aux mentions légales, aux CGV et aux coordonnées bancaires.
   */
  address: {
    streetAddress: "1 Boulevard de la Croisette",
    postalCode: "06400",
    city: "Cannes",
    country: "France",
    /** Pointeur de la fiche Google (Localnord, lu le 10/10/2026). */
    latitude: 43.551206,
    longitude: 7.0171012,
  },
  legal: {
    siren: "911269736",
    siret: "91126973600011",
    vat: "FR20911269736",
    legalForm: "SASU",
    legalFormFull: "SASU, société par actions simplifiée unipersonnelle",
    rcsCity: "Cannes",
    rcsNumber: "911 269 736 R.C.S. Cannes",
    rcsRegistrationDate: "11/03/2022",
    vtcLicense: "Sur demande",
    addressLine1: "18 IMP DE VILLAMONT",
    postalCode: "06110",
    city: "LE CANNET",
    country: "France",
    director: "Khoula Sofiane",
    /** Nom du dirigeant en ordre naturel (affichage public + schema Person). */
    directorPublic: "Sofiane Khoula",
    apeCode: "77.11A",
    activity:
      "Location de courte durée de voitures et de véhicules automobiles légers, activité VTC, chauffeur privé, import/export et commerce de véhicules.",
    capital: "10 000,00 EUR",
    staff: "0 salarié (donnée 2026)",
    createdAt: "08/03/2022",
  },
  technicalProvider: {
    company: "Next Generation",
    legalForm: "SAS (Société par Actions Simplifiée)",
    headOfficeAddress: "60 rue François 1er, 75008 Paris, France",
    siret: "992 331 322 00014",
    siren: "992 331 322",
    vat: "FR55 992 331 322",
    website: "https://www.next-generation.dev",
    email: "agence.next.generation@gmail.com",
    preferredContact:
      "Pour toute question technique, demande RGPD relative aux données techniques, ou problème lié aux cookies, veuillez contacter Next Generation à l'adresse ci-dessus.",
  },
} as const;

/** Domiciliation (siège déclaré au RCS). */
export const COMPANY_ADDRESS_SINGLE_LINE = `${COMPANY.legal.addressLine1}, ${COMPANY.legal.postalCode} ${COMPANY.legal.city}, ${COMPANY.legal.country}`;

/** Adresse publique de l'établissement, identique à la fiche Google. */
export const COMPANY_PUBLIC_ADDRESS_SINGLE_LINE = `${COMPANY.address.streetAddress}, ${COMPANY.address.postalCode} ${COMPANY.address.city}, ${COMPANY.address.country}`;
